import styled from "styled-components";

export const Container = styled.main`
    display: flex;
    flex-direction: column;
    margin-top: 75px;
    padding: 0 10px;
    width: 100%;
    @media (min-width: 720px) {
        margin: 40px 0 0 200px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        margin-left: 25px;
    }
`;

export const ContainerButtons = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: var(--space-1);
    gap: 15px;
    width: 100%;
    padding-block: 15px;
`;